import classes from './List.module.scss'
import { Children } from 'react'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode | ReactNode[]
  isOrderedList?: boolean
  variant?: 'default' | 'description'
}

const List = ({
  isOrderedList = false,
  children,
  variant = 'default'
}: Props) => {
  const isArray = Array.isArray(children)

  const ListTag = isOrderedList
    ? 'ol'
    : 'ul'

  const tagColor = variant === 'description'
    ? classes.ListDescription
    : classes.ListDefault

  return (
    isArray
      ? (
        <ListTag className={tagColor}>
          {
            Children.map(children, (child: ReactNode, index: number) =>
              <li key={index}>
                {child}
              </li>
            )
          }
        </ListTag>
      )
      : (
        <ListTag className={tagColor}>
          <li>
            {children}
          </li>
        </ListTag>
      )
  )
}

export default List
